export const contentData = {
    spanish: {
        title: 'Estadísticas - Evaluaciones',
        button: null,
        nodata: 'Sin Registro',
    }
}
